import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { logOut } from "..";
import { cleanStorage } from "./storage";
import { useHistory } from 'react-router-dom';

export var Logout = function Logout() {
    var dispatch = useDispatch();
    var abortController = new AbortController();
    var history = useHistory();

    useEffect(function () {
        fetch(process.env.REACT_APP_API_GATEWAY + "/auths/oauth2/logout", {
            method: 'POST',
            credentials: 'include',
            signal: abortController.signal
        }).then(function () {
            cleanStorage();
            dispatch(logOut());
            history.push('/');
        });

        return function () {
            return abortController.abort();
        };
    }, [abortController, history, dispatch]);

    return null;
};